/* Add  Type to recInfo  June 25, 2022 */
/* Add  Proposal(PS) to Altview  Jan 8, 2022 */
/* Add step="any" to number input Jan 21, 2023*/
/* Add fn_addCustomFields Aug 5, 2023 */
/* Add Opportunity Team OT Dec 30, 2023 */
/* Add kt-notes,d_savedRecord Feb 17, 2024 */
/* Add m_processVoice June 1, 2024 */
/* Add c_value for showing value Jul 31, 2024 */
/* Add p_mode to custom-field Aug 24, 2024 */
/* Add OpportunityTeamEmail,m_opportunityTeamEmail Sep 21, 2024 */
/* Add readonly, required Columns columns Jan 25, 2025 */
/* Add required Indicator Feb 15, 2025 */
/* Remove Notes May 30, 2025 */
/* Add photo June 21, 2025 */
/* Add Full Proposal CPS June 29, 2026 */
/* Add p_recData to Business Insight  Apr 11, 2026 */
/* GUI changes Phase1  May 15, 2026 */
<template lang="pug">
	//- keep extra div here for all recs Prevent multiple/nested re-wrap?
	div
		rec-wrap(:p_mode="p_mode" :p_saveFn="m_saveFn" p_appEntKey="oppr" :p_isModal="p_isModal" p_enableClone=true
		:p_requiredColumns="d_requiredColumns" :p_recData="d_recData" :p_rmndOpt="d_rmndOpt" :p_altView="d_altViewKey" @altViewChg="d_altViewKey = $event"
		@canceled="m_uxReset()" @generatePdf="m_generatePdf" @previewPdf="m_previewPdf" @saveProposal="m_saveProposal"
		@saveProposalTemplate="m_saveProposalTemplate" @applyProposalTemplate="m_applyProposalTemplate"
		@OpportunityTeamPdf="m_opportunityTeamPdf"  @OpportunityTeamExcel="m_opportunityTeamExcel" @OpportunityTeamEmail="m_opportunityTeamEmail" @focused="d_currentFocus = $event" @voice="m_processVoice")
			//- template(v-slot:rec-wrap-flow)
				div(class="oppr-type-flow topHeader")
					div(v-for="(ot,ix) in c_opprTypes" :key="ix" :class="ot.flowClass") 
						span
						span {{ot.name}}
			template(v-slot:rec-form-header)
				div(class="d-flex raisedHeader")
					div(class="form-group"  style="text-align:left;width:20%" )
						kt-photo(id="opportunityPhoto" ref="kt-photo" p_prntRecKey="oppr" :p_recInfo="c_recInfo" :p_photoRec="c_photoRec")
					div(style="width:60%;")
						kt-progress-status(id="progressStatus"  p_entity="oppr" p_title="Pursuit Progress" :p_statusId="d_recData.opportunitySubStatusId" :p_statuses="c_subStatues")
					div(class="milestoneClass")
						<span class="d-block"><span style="color:#4fa4ff">Project Value:</span><span style="color:#556E8D;font-size:20px;">{{c_value}}</span></span> 
						<span class="d-block"><span style="color:#4fa4ff">Due Date:</span><span style="color:#556E8D;font-size:20px;">{{c_dueDate}}</span></span>
			template(v-slot:rec-form-left)
				span <span style="color:#ff9333;">*</span>indicates field is required.
				div(class="form-group")
					label(class="required-label") Opportunity #
					b-form-input(class="styled-input" size="sm" id="opportunityNo" v-model="d_recData.opportunityNo" disabled placeholder="Auto Generated"  )
				div(class="form-group")
					label(class="required-label")  Opportunity Name
					b-form-input(class="styled-input" size="sm" id="opportunityName" v-model="d_recData.opportunityName" required)
				div(class="form-group")
					label Site Address
					kt-address(id="siteAddress" :p_recData="d_recData" :p_readOnly="p_mode=='view'||m_readOnly('siteAddress')" p_appEntKey='oppr')
				div(class="form-group")
					label(:class="m_required('clientAccountId')?'required-label':''") Client
					kt-select(
						p_appEntKey="acct"
						id="clientAccountId"
						:p_currentVal="d_recData.clientAccount"
						:p_readOnly="p_mode=='view'||m_readOnly('clientAccountId')"
						:p_enableCreate="true"
						@change="d_recData.clientAccount = $event; d_recData.clientAccountId = ($event||{}).accountId||null;"
					)
				div(class="form-group")
					label(:class="m_required('clientAccounts')?'required-label':''") Additional Client(s)
					kt-list(
						p_appEntKey="acct"
						id="clientAccounts"
						:p_currentVals="d_recData.clientAccounts"
						:p_readOnly="p_mode=='view'||m_readOnly('clientAccounts')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.clientAccounts = $event"
					)
				div(class="form-group")
					label(:class="m_required('primaryClientAccountContactId')?'required-label':''") Primary Client Contact
					kt-select(
						p_appEntKey="extr"
						id="primaryClientAccountContactId"
						:p_currentVal="d_recData.primaryClientAccountContact"
						:p_readOnly="p_mode=='view'||m_readOnly('primaryClientAccountContactId')"
						:p_enableCreate="true"
						:p_filterFirstKey="d_recData.clientAccountId"
						@change="d_recData.primaryClientAccountContact = $event; d_recData.primaryClientAccountContactId = ($event||{}).externalContactId||null;"
					)
				div(class="form-group")
					label(:class="m_required('designerAccounts')?'required-label':''") Designer(s)
					kt-tt-info(p_infoTxt="Architects, Engineers (Etc.)")
					kt-list(
						p_appEntKey="acct"
						id="designerAccounts"
						:p_currentVals="d_recData.designerAccounts"
						:p_readOnly="p_mode=='view'||m_readOnly('designerAccounts')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.designerAccounts = $event"
					)
				div(class="form-group")
					label(:class="m_required('competitors')?'required-label':''") Competitor(s)
					kt-tt-info(p_infoTxt="Companies you are competing against")
					kt-list(
						p_appEntKey="cmpt"
						id="competitors"
						:p_currentVals="d_recData.competitors"
						:p_readOnly="p_mode=='view'||m_readOnly('competitors')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.competitors = $event"
						
					)
				div(class="form-group")
					label(:class="m_required('internalContactId')?'required-label':''") Internal Contact
					kt-tt-info(p_infoTxt="Your team member in charge of opportunity")
					kt-select(
						p_appEntKey="team"
						id="internalContactId"
						:p_currentVal="d_recData.internalContact"
						:p_readOnly="p_mode=='view'||m_readOnly('internalContactId')"
						:p_enableCreate="true"
						@change="d_recData.internalContact = $event; d_recData.internalContactId = ($event||{}).teamMemberId||null;"
					)
				div(class="form-group")
					label(:class="m_required('assignedTeamMembers')?'required-label':''") Assigned Team Member(s)
					kt-tt-info(p_infoTxt="Other team members assisting with opportunity")
					kt-list(
						p_appEntKey="team"
						id="assignedTeamMembers"
						:p_currentVals="d_recData.assignedTeamMembers"
						:p_readOnly="p_mode=='view'||m_readOnly('assignedTeamMembers')"
						:p_enableCreate="true"
						:p_enableAdd="true"
						@change="d_recData.assignedTeamMembers = $event"					
					)

			template(v-slot:rec-form-right)
				div(class="form-group")
					label(:class="m_required('opportunityStatusId')?'required-label':''") Opportunity Status
					div
						b-form-select(class="styled-input" id="opportunityStatusId" size="sm"  v-model="d_recData.opportunityStatusId" :options="c_opprStatuses"
						value-field="id" text-field="name" required)
					span(v-if="c_createProj" class="note") Note: A new Project will be created for this opportunity after saving.
					span(v-if="d_ux.secdt" class="note") "Secured Date" is set to today's date. You may update accordingly.
				div(class="form-group1")
					label(:class="m_required('opportunitySubStatusId')?'required-label':''") Opportunity Sub-Status
					div
						b-form-select(class="styled-input" id="opportunitySubStatusId" size="sm"  v-model="d_recData.opportunitySubStatusId" 
						:options="d_ref.selOpt(d_ref.opportunitySubStatuses, d_recData.opportunitySubStatusId)"
						value-field="id" text-field="name" )
				div(class="form-group")
					label(:class="m_required('opportunityTypeId')?'required-label':''") Opportunity Stage
					div
						b-form-select(class="styled-input" id="opportunityTypeId" size="sm"  v-model="d_recData.opportunityTypeId" :options="c_opprTypes"
						value-field="id" text-field="name" )
				div(class="form-group")
					label(:class="m_required('categoryId')?'required-label':''") Category
					div
						b-form-select(class="styled-input" id="categoryId" size="sm"  v-model="d_recData.categoryId" :options="d_ref.selOpt(d_ref.categories,d_recData.categoryId)"
						value-field="id" text-field="name" )

					//- span(v-if="c_createProj" class="note") Note: A new Project will be created after saving.
					span(v-if="d_ux.awddt" class="note") "Awarded Date" is set to today's date. You may update accordingly.			
				div(v-show="d_recData.project" class="form-group")
					label(:class="m_required('project')?'required-label':''") Project
					kt-select(
						p_appEntKey="proj"
						id="project"
						:p_currentVal="d_recData.project"
						:p_readOnly="true"
						:p_enableCreate="false"
					)
				div(class="form-group")
					label(:class="m_required('contractTypeId')?'required-label':''")  Contract Type
					div
						b-form-select(class="styled-input" id="contractTypeId" size="sm" v-model="d_recData.contractTypeId" 
						:options="d_ref.selOpt(d_ref.contractTypes, d_recData.contractTypeId)"
						value-field="id" text-field="name" )
				div(class="form-group")
					label(:class="m_required('marketSegmentId')?'required-label':''") Market Segment
					div
						b-form-select(class="styled-input" id="marketSegmentId" size="sm" v-model="d_recData.marketSegmentId" 
						:options="d_ref.selOpt(d_ref.marketSegments, d_recData.marketSegmentId)"
						value-field="id" text-field="name" )
				div(class="form-group")
					label(:class="m_required('leadSourceId')?'required-label':''") Lead Source
					kt-tt-info(p_infoTxt="Who is your source for this opportunity")
					div
						b-form-select(class="styled-input" id="leadSourceId"  size="sm" v-model="d_recData.leadSourceId" 
						:options="d_ref.selOpt(d_ref.leadSources, d_recData.leadSourceId)"
						value-field="id" text-field="name" )
				div(class="form-group")
					label(:class="m_required('projectSize')?'required-label':''") Project Size
					b-input-group(size="sm" prepend="sf"  )
						b-form-input(class="styled-input" id="projectSize" v-model="d_recData.projectSize" type="number" step="any")
				div(class="form-group")
					label(:class="m_required('value')?'required-label':''") Value
					b-input-group(size="sm" prepend="$"  )
						b-form-input(v-if="p_mode == 'edit'||p_mode == 'create'" class="styled-input" id="value" v-model="d_recData.value"  type="number" step="any")
						b-form-input(v-else class="styled-input" id="valueText" v-model="c_value")
				div(class="form-group")
					label Value per sq ft
					kt-tt-info(p_infoTxt="Cost per Square foot")
					b-input-group(size="sm" prepend="$"  )
						b-form-input(class="styled-input" id="psqft" v-model="(d_recData.value/d_recData.projectSize).toFixed(2)" readonly type="number" step="any")
				div(class="form-group")
					label(:class="m_required('winProbability')?'required-label':''") Win Probability
					kt-tt-info(p_infoTxt="Likelihood of you winning the work")
					div
						b-form-select(class="styled-input" id="winProbability" size="sm" v-model="d_recData.winProbability" :options="d_ref.probabilities" )
				div(class="form-group")
					label(:class="m_required('secureProbability')?'required-label':''") Secure Probability
					kt-tt-info(p_infoTxt="Likelihood the project will begin at your secure time")
					div
						b-form-select(class="styled-input" id="secureProbability" size="sm"  v-model="d_recData.secureProbability" :options="d_ref.probabilities")
				div(class="form-group")
					label(:class="m_required('dueDate')?'required-label':''") Due Date
					kt-tt-info(p_infoTxt="Date proposal is due")
					b-form-input(class="styled-input" id="dueDate" size="sm"  v-model="d_recData.dueDate" type="date" )
				div(class="form-group")
					label(:class="m_required('awardDate')?'required-label':''") Awarded Date
					kt-tt-info(p_infoTxt="Date work was awarded to you")
					b-form-input(class="styled-input" id="awardedDate" size="sm"  v-model="d_recData.awardedDate" type="date"
					@change="d_ux.awddt=false")
				div(class="form-group")
					label(:class="m_required('securedDate')?'required-label':''") Secured Date
					kt-tt-info(p_infoTxt="Contract has been signed and work is about to commence")
					b-form-input(class="styled-input" id="securedDate" size="sm" v-model="d_recData.securedDate" type="date"
					@change="d_ux.secdt=false")
				div(class="form-group")
					label(:class="m_required('siteWalkThroughDate')?'required-label':''") Site Walk Through Date
					b-form-input(class="styled-input" id="siteWalkThroughDate" size="sm"  v-model="d_recData.siteWalkThroughDate" type="date" )
				div(class="form-group")
					label(:class="m_required('siteWalkThroughDate')?'required-label':''") Approx Construction Start Date
					b-form-input(class="styled-input" id="approxConstructionStartDate" size="sm" v-model="d_recData.approxConstructionStartDate" type="date"  )
				div(class="form-group")
					label(:class="m_required('siteWalkThroughDate')?'required-label':''") Approx Construction Completion Date
					b-form-input(class="styled-input" id="approxConstructionCompletionDate"  size="sm" v-model="d_recData.approxConstructionCompletionDate" type="date"  )
			template(v-slot:rec-form-center)
				div(class="form-group")
					label(:class="m_required('opportunityDetails')?'required-label':''") Scope of Work
					b-input-group-prepend(size="sm" class="px-0")
						b-input-group-text
							fa-icon(icon="list-ul")
						b-form-textarea(class="styled-input" id="opportunityDetails"  size="sm" v-model="d_recData.opportunityDetails" rows=5)
				div(class="form-group")
					label(:class="m_required('projectInformation')?'required-label':''") Project Information
					b-input-group-prepend(class="px-0")
						b-input-group-text
							fa-icon(icon="trophy")
						b-form-textarea(class="styled-input" id="projectInformation"  size="sm" v-model="d_recData.projectInformation" rows=5)
				kt-custom-field(v-if="d_customFields.length>0" :p_mode="p_mode"  p_prntRecKey="oppr" :p_recData="d_recData.customData"  @change="d_recData.customData=$event")
			template(v-slot:rec-alt-view)
				kt-tasks(v-if="d_altViewKey=='TASK'" ref="kt-tasks" p_prntRecKey="oppr" :p_prntRecInfo="c_recInfo" p_enableCUFilter=true)
				kt-attach(v-else-if="d_altViewKey == 'AT'" ref="kt-attach" p_prntRecKey="oppr" :p_recInfo="c_recInfo")
				kt-decisions(v-else-if="d_altViewKey == 'DECS'" :p_recInfo="c_recInfo")
				kt-business-insights(v-else-if="d_altViewKey == 'BI'" :p_recInfo="c_recInfo" :p_recData="c_recData")
				kt-debrief(v-else-if="d_altViewKey == 'DB'" :p_recInfo="c_recInfo")
				kt-proposal(v-else-if="d_altViewKey == 'PS'" ref="proposal" :p_recInfo="c_recInfo" :p_recData="c_recData")
				kt-opportunityTeam(v-else-if="d_altViewKey == 'OT'" ref="opportunityTeam" :p_opportunityId="d_recData.opportunityId" 
									:p_opportunityName="d_recData.opportunityName")
				kt-complete-proposal(v-else-if="d_altViewKey == 'CPS'" ref="proposal" :p_recInfo="c_recInfo" :p_recData="c_recData")
</template>

<script>

import {fn_fmtMoney,fn_fmtDt,fn_getHashId, fn_getModal_confirm, fn_isoDtStr} from "@/utils/util.js";
import {fn_saveRecord} from "@/utils/api.js";
import {refData,userSettings} from "@/utils/ref-data.js";
import RecWrap from "@/components/RecWrap.vue";
import KTList from "@/components/Ctrl/KT-List.vue";
import KTAddress from "@/components/Ctrl/KT-Address.vue";
import KTCustomField from "@/components/Ctrl/KT-CustomField.vue";


export default {
	name: "oppr-rec",
	components: {
		'rec-wrap': RecWrap,
		'kt-list': KTList,
		'kt-address': KTAddress,
		'kt-tasks': () => import("@/components/Ctrl/KT-Tasks.vue"),
		'kt-attach': () => import("@/components/Ctrl/KT-Attach.vue"),
		'kt-decisions': () => import("@/components/Ctrl/KT-Decisions.vue"),
		'kt-business-insights': () => import("@/components/Ctrl/KT-BusinessInsights.vue"),
		'kt-debrief': () => import("@/components/Ctrl/KT-Debrief.vue"),
		'kt-proposal': () => import("@/components/Ctrl/KT-Proposal.vue"),
		'kt-complete-proposal': () => import("@/components/Ctrl/CompleteProposalHome.vue"),
		'kt-opportunityTeam': () => import("@/components/Ctrl/KT-OpportunityTeam.vue"),
		'kt-custom-field': KTCustomField,
		'kt-photo': () => import("@/components/Ctrl/KT-Photo.vue"),
		'kt-progress-status': () => import("@/components/Ctrl/KT-ProgressStatus.vue"),
	},
	created() {
		if (this.p_mode != 'create' && !this.p_recNo) {
			this.d_recNo = fn_getHashId(this);
		}
		else if (this.p_recNo) {//Applies for modal only?
			this.d_recNo = this.p_recNo;
		}
		if (!this.d_recNo) {
			this.m_setDefaults();
		}
	const usrOpts = (userSettings && userSettings.userOptions) || {};

	const readOnlyCols = usrOpts.tableReadOnlyColumns &&
    Array.isArray(usrOpts.tableReadOnlyColumns['kt-table-oppr'])
        ? usrOpts.tableReadOnlyColumns['kt-table-oppr']
        : [];

	const requiredCols = usrOpts.tableRequiredColumns &&
    Array.isArray(usrOpts.tableRequiredColumns['kt-table-oppr'])
        ? usrOpts.tableRequiredColumns['kt-table-oppr']
        : [];

	this.d_readOnlyColumns = readOnlyCols;
	this.d_requiredColumns = requiredCols;

		// Safely extract fields
		this.d_requiredFields = requiredCols
		.filter(c => c && typeof c.field === 'string')
		.map(c => c.field);

		console.log('In opprRec Created');
		console.log(userSettings.userOptions);
		

	},
	mounted() {
		this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
	},
	data() {
		return {
			d_recNo: null,
			d_recData: {},
			d_rmndOpt: [], //Keep empty array here
			d_ref: refData,
			d_altViewKey: null,
			d_ux: {
				dbrf: false, //Debrief Prompt
				secdt: false, //Secured Date Set
				awddt: false //Awarded Date Set
			},
			d_noClone: [
				'opportunityStatusId',
				'opportunityTypeId',
				'project',
				'siteWalkThroughDate',
				'dueDate',
				'approxConstructionStartDate',
				'approxConstructionCompletionDate',
				'securedDate',
			],
			d_customFields:refData.customFields.filter(c=>(c.context=='oppr')),
			d_savedRecord:null,
			d_currentFocus:null,
			d_readOnlyColumns:[],
			d_requiredColumns:[],
			d_requiredFields:[],
		};
	},
	props: {
		p_recNo: String,
		p_mode: String,
		p_isModal: Boolean,
	},
	provide() {return {vcrec: this}},
	computed: {
		c_value(){return fn_fmtMoney(this.d_recData.value);},
		c_createProj() {
			// return this.m_isOpprType('Awarded') && !this.d_recData.project;
			return this.m_isOpprStatus('Secured') && !this.d_recData.project;
		},
		c_opprStatuses() {
			let os = refData.opportunityStatuses.map(x => ({...x}));
			if (this.p_mode == 'create') fn_disableHelper(os, ['Secured', 'Archived']);

			if (this.p_mode != 'view') {
				if (this.m_isOpprType('Awarded')) fn_disableHelper(os, ['Open', 'Submitted', 'Bidding', 'Not Pursued', 'Not Awarded']);
			}
			return os;
		},
		c_opprTypes() {
			let ot = refData.opportunityTypes.map(x => ({...x}));
			if (this.p_mode == 'create')
				fn_disableHelper(ot, 'Awarded');

			if (this.p_mode != 'view') {
				if (this.m_isOpprStatus(['Not Pursued']))
					fn_disableHelper(ot, 'Awarded');
			}
			//No need for ClearOT

			let otid = this.d_recData.opportunityTypeId;
			ot.forEach(x => {
				let fc = x.flowClass = [];
				if (x.id == otid) fc.push('curr');
				if (x.id < otid) fc.push('prev');
			});

			return ot;
		},		
		c_hideForm() {
			return this.d_ctrlKey != null;
		},
		c_recInfo() {
			let rd = this.d_recData;
			let recInfo = {
				Type:'opportunity',
				Id: rd.opportunityId,
				No: rd.opportunityNo,
				Name: rd.opportunityName,
				Team: [rd.internalContact, ...(rd.assignedTeamMembers || [])].filter(x => x != undefined)
			};
			if (this.d_altViewKey == 'BI') recInfo.opprValue = rd.value;
			return recInfo;
		},
		c_recData(){ return this.d_recData;},
		c_photoRec() {
			let rd = this.d_recData;
			return {
				photoId: rd.photoId,
				photoURL: rd.photoURL,
				photoName: rd.photoName
			};
		},
		c_subStatues(){return this.d_ref.opportunitySubStatuses;},
		c_dueDate(){return fn_fmtDt(this.d_recData.dueDate);},
	},
	methods: {
		m_processVoice(e){	
			document.getElementById(this.d_currentFocus).value=e;
		},
		m_saveProposal(){this.$refs.proposal.m_saveProposal();},
		m_saveProposalTemplate(data){this.$refs.proposal.m_saveProposalTemplate(data);	},
		m_applyProposalTemplate(data){this.$refs.proposal.m_applyProposalTemplate(data);},
		m_generatePdf(){ this.$refs.proposal.m_generatePdf();},
		//m_emailPdf(){this.$refs.proposal.m_emailPdf();},
		m_previewPdf(){this.$refs.proposal.m_previewPdf();},
		m_opportunityTeamPdf(){this.$refs.opportunityTeam.m_generatePdf();},
		m_opportunityTeamExcel(){this.$refs.opportunityTeam.m_generateExcel();},
		m_saveFn() { //Called from  RecWrap, KTList, KTSelect
			let id = this.p_mode == 'edit' ? this.d_recData.opportunityId : null;
			this.d_savedRecord=true;
			return fn_saveRecord('opportunity', id, this.d_recData);
		},
		m_isOpprStatus(names, opprStatusId) {
			if (typeof (names) == "string") names = [names];
			let osid = opprStatusId || this.d_recData.opportunityStatusId;
			return refData.opportunityStatuses.filter(x => names.indexOf(x.name) > -1 && x.id == osid).length > 0;
		},
		m_isOpprType(names, opprTypeId) {
			if (typeof (names) == "string") names = [names];
			let otid = opprTypeId || this.d_recData.opportunityTypeId;
			return refData.opportunityTypes.filter(x => names.indexOf(x.name) > -1 && x.id == otid).length > 0;
		},
		m_setDefaults() {
			this.d_recData.opportunityStatusId = refData.opportunityStatuses.filter(x => x.name == 'Open')[0].id;
			let otLead = refData.opportunityTypes.filter(x => x.name == 'Lead')[0].id;
			this.$set(this.d_recData, 'opportunityTypeId', otLead);
		},
		m_uxReset() {
			Object.keys(this.d_ux).forEach(k => this.d_ux[k] = false);
		},
		m_customData(customData){
		this.d_recData.customData=customData;
		},
		m_opportunityTeamEmail(){this.$refs.opportunityTeam.m_exportEmails();},
		m_readOnly(col){return (this.d_readOnlyColumns&&this.d_readOnlyColumns.includes(col))?true:false;},
		m_required(col){return (this.d_requiredFields&&this.d_requiredFields.includes(col))?true:false;},	
	},
	watch: {
		d_recNo(nv, ov) {
			this.m_uxReset();
		},
		p_mode(nv, ov) {
			if (nv == 'edit') {
				this.$watch('d_recData.opportunityStatusId', (newVal, oldVal) => {
					let isSec = this.m_isOpprStatus('Secured', newVal);
					let isNA = this.m_isOpprStatus('Not Awarded', newVal);

					let dux = this.d_ux;
					dux.dbrf = isSec || isNA;

					let rd = this.d_recData;
					if (isSec && !rd.securedDate) {
						this.$set(rd, 'securedDate', fn_isoDtStr());
						dux.secdt = true;
					}
					else if (!isSec && dux.secdt) {
						rd.securedDate = null;
						dux.secdt = false;
					}

					let clrOs = this.c_opprStatuses.filter(x => x.disabled && x.id == rd.opportunityStatusId).length > 0;
					if (clrOs) rd.opportunityStatusId = null;

				});
				this.$watch('d_recData.opportunityTypeId', (newVal, oldVal) => {
					let isAwd = this.m_isOpprType('Awarded', newVal);

					let dux = this.d_ux;
					let rd = this.d_recData;

					if (isAwd && !rd.awardedDate) {
						this.$set(rd, 'awardedDate', fn_isoDtStr());
						dux.awddt = true;
					}
					else if (!isAwd && dux.awddt) {
						rd.awardedDate = null;
						dux.awddt = false;
					}
				});
			}
			else if (nv == 'view' && this.d_ux.dbrf) {
				if (this.d_ux.dbrf) fn_promptDebrief(this);
				this.m_uxReset(); //Must reset **AFTER** the above step.
			}
			if (nv == 'edit' || nv == 'create'){
				this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
			}
		},
	}
};
function fn_disableHelper(array, names) {
	if (typeof (names) == "string") names = [names];
	array.filter(x => names.indexOf(x.name) > -1).forEach(x => x.disabled = true);
}

function fn_promptDebrief(vc) {

	let osNm = (vc.c_opprStatuses.filter(x => x.id == vc.d_recData.opportunityStatusId)[0] || {}).name;
	let content = {
		titleIcon: 'clipboard-list',
		titleText: osNm + ' Opportunity Debrief',
		message1: `Do you want to go to the Debrief section to record feeback about the opportunity?`,
		message2: `You may also do this at a later time by clicking on "Debrief" at the top of the opportunity's page.`
	};
	let cm = fn_getModal_confirm(vc, content);
	cm.opt.okTitle += ', Go to Debrief';
	cm.opt.cancelTitle += ', Not Now';
	vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
		if (!resp) return;
		vc.d_altViewKey = 'DB';
	});
}


</script>
<style lang="less">
.topHeader {
	position:fixed;
	z-index: 9;
}
.milestoneClass {
	position: relative;
    top: 50px;
	margin-left: 50px;
	//text-align:left;
	width:20%;
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
.raisedHeader{
	position1:fixed;
	width:1130px;
	padding: 10px;
	background-color: white;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
	border-radius: 8px;
	z-index1: 9;
	}
.raisedHeader img {
	border-radius: 8px;
}
</style>